<div class="modal-body">
  <div class="modal-text-wrapper-info">
    <p class="title">{{ title }}</p>
    @if (information) {
      <p class="body" style="white-space: pre-line">{{ information }}</p>
    }
  </div>
</div>
